<template lang="pug">

v-select(
    v-model="model"
    :label="label"
    :color="color"
    :items="customItems"
    :item-text="itemText"
    :item-value="itemValue"
    :disabled="disabled"
    :error-messages="errorMessages"
  )
  template(slot="selection" slot-scope="data")
    span.item--selected(:selected="data.selected" close @input="remove(data.item)")
      | {{ data.item.name }}
  template(slot="item" slot-scope="data")
    template(v-if="typeof data.item !== 'object'")
      v-list-tile-content(:class="data.item._itemType" v-text="data.item")
    template(v-else)
      v-list-tile-content
        v-list-tile-title
          span(:class="data.item._itemType" v-html="data.item.name")

</template>

<script>
import vmodelMixin from '@/mixins/v-model-for-custom-input-controls.js'

export default {
  mixins: [ vmodelMixin ],
  props: {
    items: Array,
    itemText: String,
    itemValue: String
  },
  data: () => ({
    customItems: []
  }),
  mounted () {
    this.unifyItems()
  },
  methods: {
    unifyItems () {
      const items = []
      this.items.forEach(item => {
        if (item.items && item.items.length) {
          items.push({ header: item[this.itemText] })
          items.push(...item.items)
          items.push({ divider: true })
        } else {
          items.push(item)
        }
      })
      this.customItems = this.setFormatItems(items)
    },
    setFormatItems (items) {
      for (let i = 0, len = items.length; i < len; i++) {
        const lastItemPosition = i - 1
        if (!typeof items[lastItemPosition] === 'object' || !items[lastItemPosition] || items[i].divider) continue
        if (items[lastItemPosition].header || items[lastItemPosition]._itemType === 'option-group') {
          items[i]._itemType = 'option-group'
        }
      }
      return items
    }
  },
  watch: {
    items () {
      this.unifyItems()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/variables'

.v-select >>> .v-select__selections
  width: "calc(100% - %s)" % $f28px

.item--selected
  display: inline-block
  overflow: hidden
  text-overflow: ellipsis
  width: 100%
  white-space: nowrap

.option-group
  padding-left: $f20px

</style>
